import type { ReactElement } from 'react'

import { useOpenChat } from '../../code-only/lib/index.ts'
import { useTranslate } from '../../code-only/localization/index.ts'
import { Avatar, Button } from '../../components/index.ts'

export function CompactHeaderContactButton(): ReactElement {
  const openChat = useOpenChat()
  const translate = useTranslate()
  return (
    <Button
      variant="secondary"
      size="medium"
      avatar={<Avatar icon="comment-regular" />}
      ariaLabel={translate('contact_customer_support')}
      onClick={openChat}
    />
  )
}
